/**
 * @fileoverview POST handler for the "/apps/:app_group_id/bot_tracking_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdBotTrackingSettingsCacheKeys } from "./constants";
import type { PostAppsAppGroupIdBotTrackingSettingsProps, PostBotTrackingSettingsResult } from "./types";

export const postBotTrackingSettings = reactQueryMutationAdapter(
  appsAppGroupIdBotTrackingSettingsCacheKeys,
  ({
    appGroupId,
    ...props
  }: PostAppsAppGroupIdBotTrackingSettingsProps): Promise<PostBotTrackingSettingsResult> => {
    return fetch(`/apps/${appGroupId}/bot_tracking_settings`, "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
